/* dz-videos.js — bloc dz-videos « Porté en vrai » de la fiche du pull demi-zip (StefLuxe, chantier stefluxe-pack-demizip, 30/10/2026).
   Rail (owner 30/10 : « elles doivent défiler et se lancer automatiquement ») : chaque carte visible à ≥ 60 % joue toute seule, muette, en boucle
   (3 au plus, 1 seule en 3G) ; le rail avance d'une carte toutes les 3,5 s tant qu'il est à l'écran, et revient au début après la dernière ; un
   toucher, la molette, le clavier ou la souris sur le rail l'arrêtent, il repart 6 s après. Rien ne bouge avec « Réduire les animations »,
   « Économiseur de données » ou en 2G (l'image d'aperçu reste), ni onglet caché, ni lecteur ouvert. Une carte qui cesse de jouer est vidée (pause,
   source retirée) : mémoire et données ne s'accumulent pas pendant le défilement. Source : le flux adaptatif HLS si le navigateur le lit (il ne
   charge que la qualité utile), sinon le mp4 servi (1080 p, 2,5 Mbps). Lecteur : un toucher ouvre la vidéo en grand (dialog modale), précédent /
   suivant (flèches du clavier comprises), enchaîne la suivante à la fin, « Choisir mon offre » ferme et ramène au choix de l'offre (#dz-pack, sinon
   le bouton natif). Clics par délégation sur document ; une seule exécution même si le script est inclus deux fois.
   Fonctions pures exposées sur window.DZ (tests/logique.test.mjs) ; DZ.pas / DZ.reprise (ms) remplaçables par un test. */
(function () {
  'use strict';
  var DZ = window.DZ = window.DZ || {};
  if (DZ.videosCharge) return;
  DZ.videosCharge = true;

  /* <logique-videos> — fonctions pures, testées telles quelles */
  // Cartes à faire jouer : celles à ≥ seuil, les plus visibles d'abord (égalité : celles qui jouent déjà, puis l'ordre du rail), au plus max ;
  // rendues dans l'ordre du rail.
  DZ.elus = function (ratios, actifs, seuil, max) {
    var s = seuil == null ? 0.6 : seuil, m = max == null ? 3 : max, c = [], i;
    for (i = 0; i < ratios.length; i++) if (ratios[i] >= s) c.push(i);
    c.sort(function (a, b) { return (ratios[b] - ratios[a]) || ((actifs.indexOf(b) >= 0) - (actifs.indexOf(a) >= 0)) || (a - b); });
    return c.slice(0, Math.max(0, m)).sort(function (a, b) { return a - b; });
  };
  // Défilement automatique : position du rail une carte plus loin (pas = largeur d'une carte + écart), alignée sur les cartes ; au bout ⇒ 0 (retour
  // au début) ; rien à faire défiler (toutes les cartes tiennent) ⇒ -1.
  DZ.suivant = function (gauche, largeur, total, pas) {
    var max = total - largeur;
    if (!(pas > 0) || !(max > 1)) return -1;
    if (gauche >= max - 2) return 0;
    return Math.min(max, (Math.floor((gauche + 2) / pas) + 1) * pas);
  };
  /* </logique-videos> */

  var connexion = function () { return navigator.connection || {}; };
  var calme = function () {
    try { if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return true; } catch (e) { /* vieux navigateur */ }
    var c = connexion();
    return !!(c.saveData || /(^|-)2g$/.test(c.effectiveType || ''));
  };
  var maxJoue = function () { return calme() ? 0 : /^3g$/.test(connexion().effectiveType || '') ? 1 : 3; };
  var hlsLu = null;
  var sourceDe = function (b) {
    if (hlsLu === null) { var t = document.createElement('video'); hlsLu = !!(t.canPlayType && (t.canPlayType('application/vnd.apple.mpegurl') || t.canPlayType('application/x-mpegURL'))); }
    return (hlsLu && b.getAttribute('data-hls')) || b.getAttribute('data-mp4');
  };
  var poser = function (v, b) { var url = sourceDe(b); v.dzBouton = b; if (v.getAttribute('src') !== url) v.src = url; };
  var jouer = function (v) { var p; try { p = v.play(); } catch (e) { return; } if (p && p.catch) p.catch(function () {}); };
  var vider = function (v) {
    try { v.pause(); } catch (e) { /* rien */ }
    if (v.hasAttribute('src')) { v.removeAttribute('src'); try { v.load(); } catch (e) { /* rien */ } }
  };

  // ── Aperçus du rail : toutes les cartes visibles jouent ──
  var cartes = [];        // vidéos d'aperçu observées, dans l'ordre du document
  var ratios = [];
  var actifs = [];        // indices des cartes qui jouent
  var lecteurOuvert = false;
  var demarrer = function (v) {
    var p;
    try { p = v.play(); } catch (e) { return; }
    var montrer = function () { if (actifs.indexOf(cartes.indexOf(v)) >= 0) v.classList.add('is-on'); };
    if (p && p.then) p.then(montrer, function () { /* lecture refusée (économie d'énergie) : l'image reste */ }); else montrer();
  };
  var elire = function () {
    var max = lecteurOuvert || document.hidden ? 0 : maxJoue();
    var vivants = ratios.map(function (x, i) { return cartes[i].isConnected ? x : 0; });
    var elus = DZ.elus(vivants, actifs, 0.6, max);
    actifs.forEach(function (i) { if (elus.indexOf(i) < 0) { cartes[i].classList.remove('is-on'); vider(cartes[i]); } });
    var neufs = elus.filter(function (i) { return actifs.indexOf(i) < 0; });
    actifs = elus;
    neufs.forEach(function (i) { var v = cartes[i]; poser(v, v.closest('.dz-vid-b')); v.muted = true; demarrer(v); });
  };
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entrees) {
    entrees.forEach(function (e) { var i = cartes.indexOf(e.target); if (i !== -1) ratios[i] = e.isIntersecting ? e.intersectionRatio : 0; });
    elire();
  }, { threshold: [0, 0.3, 0.6, 0.8, 1] }) : null;

  // ── Défilement automatique du rail ──
  var rails = [];
  var bouge = function () { return !lecteurOuvert && !document.hidden && !calme(); };
  var planifier = function (st) {
    clearTimeout(st.t);
    if (!bouge() || !st.vu || st.survol || !st.rail.isConnected) return;
    st.t = setTimeout(function () { avancer(st); }, Math.max(DZ.pas || 3500, st.repos - Date.now()));
  };
  var avancer = function (st) {
    if (!bouge() || !st.vu || st.survol || !st.rail.isConnected) return;
    if (Date.now() < st.repos) { planifier(st); return; }
    var r = st.rail, c = r.querySelector('.dz-vid'), ecart = 0;
    try { ecart = parseFloat(window.getComputedStyle(r).columnGap) || 0; } catch (e) { ecart = 0; }
    var x = c ? DZ.suivant(r.scrollLeft, r.clientWidth, r.scrollWidth, c.getBoundingClientRect().width + ecart) : -1;
    if (x < 0) return;                                  // toutes les cartes tiennent à l'écran : rien à faire défiler
    if (typeof r.scrollTo === 'function') r.scrollTo({ left: x, behavior: 'smooth' }); else r.scrollLeft = x;
    planifier(st);
  };
  var replanifier = function () { rails.forEach(planifier); };
  var ioRail = 'IntersectionObserver' in window ? new IntersectionObserver(function (entrees) {
    entrees.forEach(function (e) { rails.forEach(function (st) { if (st.rail === e.target) { st.vu = e.isIntersecting && e.intersectionRatio >= 0.5; planifier(st); } }); });
  }, { threshold: [0, 0.5, 1] }) : null;
  var suivreRail = function (r) {
    if (!ioRail || rails.some(function (st) { return st.rail === r; })) return;
    var st = { rail: r, vu: false, survol: false, repos: 0, t: 0 };
    var toucher = function () { st.repos = Date.now() + (DZ.reprise || 6000); planifier(st); };
    ['pointerdown', 'touchstart', 'wheel', 'keydown', 'focusin'].forEach(function (ev) { r.addEventListener(ev, toucher, { passive: true }); });
    r.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') { st.survol = true; clearTimeout(st.t); } });
    r.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') { st.survol = false; toucher(); } });
    rails.push(st);
    ioRail.observe(r);
  };
  var brancher = function () {
    if (!io) return;
    var vues = document.querySelectorAll('[data-dz-videos] .dz-vid-v');
    for (var i = 0; i < vues.length; i++) {
      if (cartes.indexOf(vues[i]) !== -1) continue;
      cartes.push(vues[i]); ratios.push(0); io.observe(vues[i]);
    }
    Array.prototype.forEach.call(document.querySelectorAll('[data-dz-videos] .dz-videos-rail'), suivreRail);
  };
  document.addEventListener('visibilitychange', function () { elire(); replanifier(); });
  // Flux HLS annoncé lisible mais illisible quand même : le mp4 prend le relais, pour cette vidéo et toutes les suivantes (l'erreur ne remonte pas : capture).
  document.addEventListener('error', function (e) {
    var v = e.target, b = v && v.dzBouton;
    if (!b || !hlsLu || v.getAttribute('src') !== b.getAttribute('data-hls')) return;
    hlsLu = false;
    v.src = b.getAttribute('data-mp4');
    if (actifs.indexOf(cartes.indexOf(v)) >= 0) demarrer(v);
    else if (lecteurOuvert && v.classList.contains('dz-lecteur-v')) jouer(v);
  }, true);

  // ── Lecteur ──
  var lecteur = function (racine) {
    var dlg = racine.querySelector('.dz-lecteur');
    if (!dlg || dlg.dzEtat) return dlg;
    var st = dlg.dzEtat = { racine: racine, v: dlg.querySelector('.dz-lecteur-v'), i: 0, ouvert: false, retour: null };
    var q = function (s) { return dlg.querySelector(s); };
    q('.dz-lecteur-x').addEventListener('click', function () { fermer(dlg, true); });
    q('.dz-lecteur-prec').addEventListener('click', function () { montrer(dlg, st.i - 1); });
    q('.dz-lecteur-suiv').addEventListener('click', function () { montrer(dlg, st.i + 1); });
    q('.dz-lecteur-cta').addEventListener('click', function () { fermer(dlg, false); allerOffre(); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) fermer(dlg, true); });   // fond, sur grand écran
    dlg.addEventListener('keydown', function (e) {
      if (e.target && e.target.tagName === 'VIDEO') return;                                     // les flèches avancent dans la vidéo
      if (e.key === 'ArrowLeft') { e.preventDefault(); montrer(dlg, st.i - 1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); montrer(dlg, st.i + 1); }
    });
    dlg.addEventListener('close', function () { var etait = st.ouvert; nettoyer(dlg); if (etait && st.retour && st.retour.isConnected) st.retour.focus({ preventScroll: true }); });
    st.v.addEventListener('ended', function () { if (st.ouvert) montrer(dlg, st.i + 1); });
    return dlg;
  };
  var boutonsDe = function (racine) { return Array.prototype.slice.call(racine.querySelectorAll('.dz-vid-b')); };
  var montrer = function (dlg, i) {
    var st = dlg.dzEtat, b = boutonsDe(st.racine);
    if (i < 0 || i >= b.length) return;
    st.i = i;
    var img = b[i].querySelector('img');
    st.v.poster = img ? (img.currentSrc || img.src) : '';
    poser(st.v, b[i]);
    st.v.muted = true;
    var lib = b[i].getAttribute('aria-label') || '', deux = lib.indexOf(' : ');
    st.v.setAttribute('aria-label', 'Vidéo ' + (i + 1) + ' sur ' + b.length + (deux === -1 ? '' : lib.slice(deux)));
    jouer(st.v);
    var prec = dlg.querySelector('.dz-lecteur-prec'), suiv = dlg.querySelector('.dz-lecteur-suiv');
    var cta = dlg.querySelector('.dz-lecteur-cta');
    if ((i === 0 && document.activeElement === prec) || (i === b.length - 1 && document.activeElement === suiv)) cta.focus();
    prec.disabled = i === 0;
    suiv.disabled = i === b.length - 1;
    dlg.querySelector('.dz-lecteur-n').textContent = (i + 1) + ' / ' + b.length;
  };
  var ouvrir = function (bouton) {
    var racine = bouton.closest('[data-dz-videos]');
    var dlg = racine && lecteur(racine);
    if (!dlg) return;
    var st = dlg.dzEtat;
    st.retour = bouton;
    st.ouvert = true;
    lecteurOuvert = true;
    elire(); replanifier();
    document.documentElement.classList.add('dz-noscroll');
    if (typeof dlg.showModal === 'function') { if (!dlg.open) dlg.showModal(); } else dlg.setAttribute('open', '');
    montrer(dlg, boutonsDe(racine).indexOf(bouton));
    dlg.querySelector('.dz-lecteur-x').focus({ preventScroll: true });
  };
  var nettoyer = function (dlg) {
    var st = dlg.dzEtat;
    if (!st.ouvert) return;
    st.ouvert = false;
    vider(st.v);
    st.v.removeAttribute('poster');
    document.documentElement.classList.remove('dz-noscroll');
    lecteurOuvert = false;
    elire(); replanifier();
  };
  var fermer = function (dlg, rendreFocus) {
    var st = dlg.dzEtat;
    nettoyer(dlg);                                   // tout de suite : la page doit pouvoir défiler vers l'offre dans le même geste
    if (dlg.open) { if (typeof dlg.close === 'function') dlg.close(); else dlg.removeAttribute('open'); }
    if (rendreFocus && st.retour && st.retour.isConnected) st.retour.focus({ preventScroll: true });
  };
  var allerOffre = function () {
    var cible = document.getElementById('dz-pack') || document.querySelector('[data-testid="standalone-add-to-cart"]');
    if (!cible) return;
    cible.scrollIntoView({ behavior: calme() ? 'auto' : 'smooth', block: 'start' });
    var choix = cible.querySelector && cible.querySelector('input[type="radio"]:checked');
    if (choix) choix.focus({ preventScroll: true });
  };

  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('.dz-vid-b') : null;
    if (!b || !b.closest('[data-dz-videos]')) return;
    e.preventDefault();
    ouvrir(b);
  });
  document.addEventListener('shopify:section:load', brancher);   // éditeur de thème
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', brancher); else brancher();
})();
